module.exports = __webpack_public_path__ + "img/book_2.e9a4f503.svg";